const guestLinks = [
  // ['/about_us', 'ABOUT US'],
  ["/terms_of_service", "TERMS OF SERVICE"],
  ["/privacy_policy", "PRIVACY POLICY"],
  ["/booking_webinar", "BOOK A MEETING"],
  ["/faq", "FAQ"],
  ["/users/sign_in", "LOG IN"],
  ["/users/sign_up", "SIGN UP"],
];

const loggedLinks = [
  ["/", "DASHBOARD"],
  ["/calendar", "BOOK A MEETING"],
  ["/bookings", "MY BOOKINGS"],
  ["/stats", "STATS LOCKER"],
];

// const userRepresentativeLinks = [
//   ["/", "DASHBOARD"],
//   ["/calendar", "BOOK A MEETING"],
//   ["/bookings", "MY BOOKINGS"],
//   ["/stats", "STATS LOCKER"],
//   // ["/requests/pending", "REQUESTS"],
// ];

const loggedLinksAsConsultantOrHD = [
  ["/", "DASHBOARD"],
  // ['/faculty', 'FACULTY'],
  ["/users/profile", "PROFILE"],
  // ['/about_us', 'ABOUT US']
];

const loggedSuperhost = [
  ["/", "MEDCAFE"],
  // ['/faculty', 'FACULTY'],
  ["/groups/my", "MEDMEETINGS"],
  ["/cpd", "CPD LOCKER"],
  ["/users/profile", "PROFILE"],
  ["/faq", "FAQ"],

  // ['/about_us', 'ABOUT US']
];

const loggedNotSponsor = [
  ["/", "MEDCAFE"],
  // ['/faculty', 'FACULTY'],
  // ["/groups/my", "MEDMEETINGS"],
  ["/cpd", "CPD LOCKER"],
  ["/users/profile", "PROFILE"],
  ["/faq", "FAQ"],

  // ['/about_us', 'ABOUT US']
];

const showMeetingsLinks = [
  ["/", "MEDCAFE"],
  // ['/faculty', 'FACULTY'],
  ["/groups/my", "MEDMEETINGS"],
  ["/cpd", "CPD LOCKER"],
  ["/users/profile", "PROFILE"],
  ["/faq", "FAQ"],

  // ['/about_us', 'ABOUT US']
];

const adminLinks = [
  ["/", "DASHBOARD OF STATISTICS"],
  ["/users", "USERS"],
  ["/webinars", "WEBINARS"],
  ["/sponsors", "SPONSORS"],
  ["/partnership", "PARTNERSHIP"],
  ["/users_sponsors", "CLIENTS"],
  ["/superhosts", "SUPER HOSTS"],
  ["/groups", "MEDMEETINGS"],
  ["/disciplines", "DISCIPLINES"],
  ["/calendar", "CALENDAR"],
  ["/gallery", "GALLERY"],
  ["/settings", "SETTINGS"],
  ["/feedbacks", "FEEDBACKS"],
  ["/client-url", "CLIENT URL"],
  ["/blocked_dates", "BLOCKED DATES"],
];

const hostLinks = [
  ["/", "DASHBOARD OF STATISTICS"],
  ["/users/new", "ADD USER"],
  ["/webinars", "WEBINARS"],
  ["/sponsors", "SPONSORS"],
  ["/partnership", "PARTNERSHIP"],
  ["/users_sponsors", "CLIENTS"],
  ["/disciplines", "DISCIPLINES"],
  ["/calendar", "CALENDAR"],
  ["/gallery", "GALLERY"],
  ["/settings", "SETTINGS"],
];

const showMeetings = [
  "nurse",
  "nurse_specialist",
  "midwifery",
  "registered_general_nurses",
];

const retrieveLinks = ({ logged, role, user, isRepresentative }) => {
  let links;

  if (logged) {
    if (role == "admin") {
      links = adminLinks;
    } else if (role == "host") {
      links = hostLinks;
      // } else if (isRepresentative) {
      //   links = userRepresentativeLinks;
    } else if (role === "superhost") {
      links = loggedSuperhost;
    } else {
      // if (user.user_type === 'consultant') {
      //   links = loggedLinksAsConsultantOrHD;
      // } else
      // if (user.user_type === 'hospital_doctor') {
      //   links = loggedLinksAsConsultantOrHD;
      // } else
      if (showMeetings.includes(user.user_type)) {
        links = showMeetingsLinks;
      } else if (user.user_type != "sponsor") {
        links = loggedNotSponsor;
      } else {
        links = loggedLinks;
      }
    }
  } else {
    links = guestLinks;
  }
  return links.map((e) => ({ link: e[0], text: e[1] }));
};

export {
  adminLinks,
  guestLinks,
  loggedLinks,
  loggedLinksAsConsultantOrHD,
  retrieveLinks,
};



// WEBPACK FOOTER //
// ./src/services/navLinks.js